<template>
  <div class="w-100">
    <div class="row">
      <template v-if="showWalletGate && !chargeWallet">
        <gate-wallet-manager1 :gate="gate" @wallet_id="wallet_id_manager"
                              :request-mode="requestMode"
                              :required-inputs="requiredInputs"
                              v-model="gate"/>
      </template>
      <template v-for="item in gatesConfig">
        <div
            v-if="checkGateActivation(item)"
            class="radio-option mx-2"
            :class="{ active: gate ==item.value }"
            @click="gate = item.value">

          <img class="d-block option-image-radio-box mb-2 img-fluid"
               :src="item['img']"
               alt="">
          <span class="d-block">{{ item['name'] }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import GateWalletManager1 from "../components/GateWalletManager1.vue";

import idpay from '../images/idpay.png'
import meli from '../images/meli.png'
import mellat from '../images/mellat.png'
import pasargad from '../images/pasargad.png'
import pos from '../images/pos.png'
import toman from '../images/toman.svg'
import saderat from '../images/saderat.png'
import sama from '../images/sama.png'
import sep from '../images/sep.png'
import zarinpal from '../images/zarinpal.svg'
import testGate from '../images/test.png'
import delivery_shipping from '../images/delivery_shipping.png'
import loan from '../images/loan.webp'
import wallet from '../images/wallet.png'
import parsian from '../images/parsian.png'


export default {
  name: "GateManager1",
  components: {GateWalletManager1},
  props: {
    requiredInputs: {
      default: false,
    },
    showWalletGate: {default: true, type: Boolean},
    chargeWallet: {default: false, type: Boolean},
    requestMode: {
      default: 'normal',
    }
  },
  data() {
    return {
      gate: '',
      gatesConfig: {
        mellat: {
          name: "ملت",
          value: 'mellat',
          site_info_key: 'mellat_gate_info',
          img: mellat,
        },
        parsian: {
          name: "پارسیان",
          value: 'parsian',
          site_info_key: 'parsian_gate_info',
          img: parsian,
        },
        zarinpal: {
          name: "زرین پال",
          value: 'zarinpal',
          site_info_key: 'zarinpal_merchant_id',
          img: zarinpal,
        },
        payir: {
          name: "درگاه پی",
          value: 'payir',
          site_info_key: 'payir_token',
          img: idpay,
        },
        wallet: {
          name: "کیف پول",
          value: 'wallet',
          site_info_key: 'mellat_gate_info',
          img: wallet,
        },
        pasargad: {
          name: "پاسارگاد",
          value: 'pasargad',
          site_info_key: 'pasargad_token',
          img: pasargad,
        },
        loan: {
          name: 'پرداخت به صورت قسطی',
          value: 'loan',
          site_info_key: 'loan_options',
          img: loan,
        },
        idpay: {
          name: 'ای دی پی',
          value: 'idpay',
          site_info_key: 'idpay_token',
          img: idpay,
        },
        sama: {
          name: 'درگاه سما',
          value: 'sama',
          site_info_key: 'sama_merchant_gateway',
          img: sama,
        },
        toman: {
          name: 'درگاه تومن',
          value: 'toman',
          site_info_key: 'toman_gate_info',
          img: toman,
        },
        meli: {
          name: "درگاه ملی",
          value: 'meli',
          img: meli,
          site_info_key: 'meli_gate_info',
        },
        sep: {
          name: "درگاه سپ",
          value: 'sep',
          site_info_key: 'sep_gate_info',
          img: sep,
        },
        saderat: {
          name: "صادرات",
          value: 'saderat',
          site_info_key: 'saderat_gate_info',
          img: saderat,
        },
        sep_pos: {
          name: "کارت خوان",
          value: 'sep_pos',
          site_info_key: 'sep_pos_gate_info',
          img: pos,
        },
        cash_on_delivery: {
          name: "پرداخت درب محل",
          value: 'cash_on_delivery',
          site_info_key: 'cash_on_delivery_categories',
          img: delivery_shipping,
        },
        test_gate: {
          name: "درگاه تست",
          value: 'test_gate',
          site_info_key: 'gate_status',
          img: testGate,
        },
      },
      siteInfo: [],
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    async loadSiteInfo() {
      let req = await this.$store.dispatch('DashboardSubscription/getSiteInfos')
      this.siteInfo = req.data.data.data
    },
    findAttributeOnSiteInfoPanel(attributeName) {

      const attribute = this.siteInfo.filter(siteInfo => siteInfo.name === attributeName);
      if (attribute.length > 0) {
        let result = []
        for (let i = 0; i < attribute.length; i++) {
          result.push(attribute[i].value);
        }

        return result;
      }
      return false
    },
    findAttributeOnSiteInfoWrapper(attributeName) {
      if (this.requestMode == 'normal') {
        return this.findAttributeOnSiteInfo(attributeName);
      }
      return this.findAttributeOnSiteInfoPanel(attributeName);

    },
    emitCashOnDeliveryPhoto(data) {
      data = data.target.files[0]
      this.$emit('cash_on_delivery_photo', data)
    },
    wallet_id_manager(value) {
      this.$emit('selected_wallet', value)
    },
    checkGateActivation(item) {
      if (item.value == 'test_gate') {
        return this.findAttributeOnSiteInfoWrapper('gate_status') == 1;
      }

      if (item.value == 'loan') {
        return this.findAttributeOnSiteInfoWrapper('loan_options')[0] == 1
      }

      return this.findAttributeOnSiteInfoWrapper(item.site_info_key)?.[0]?.length > 0;
    }
  },
  mounted() {
    this.loadSiteInfo()
  },
  watch: {
    gate: {
      handler: async function (newValue, oldValue) {
        if (newValue != null) {
          await this.$emit('input', this.gate)
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

:deep(.option-image-radio-box) {
  max-height: 50px;
  height: 100%;
  width: auto;
  margin: auto;
}


:deep(.radio-option) {
  border: 2px solid var(--primary);
  text-align: center;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: var(--tertiary, #fff);
}

:deep(.radio-option:hover) {
  filter: brightness(95%);
}


:deep(.radio-option .radio-indicator) {
  width: 16px;
  height: 16px;
  border: 2px solid #999;
  border-radius: 50%;
  margin-right: 0.75rem;
  position: relative;
}

:deep(.radio-option.active) {
  background-color: var(--primary);
  color: white;

}

:deep(.radio-option.active .radio-indicator) {
  border-color: #0d6efd;
}

:deep(.radio-option.active .radio-indicator::after) {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  background-color: #0d6efd;
  border-radius: 50%;
}


</style>